import React, { useState } from 'react';
import axios from 'axios';
import { KeyRound } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const ChangePasswordButton = ({ className = 'text-[#A1A1A1] hover:text-white px-2 sm:px-4' }) => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const reset = () => { setCurrent(''); setNext(''); setRepeat(''); setError(''); setDone(false); };

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next !== repeat) { setError('Nowe hasła nie są takie same'); return; }
    setBusy(true);
    try {
      await axios.post(`${API_URL}/api/auth/change-password`,
        { current_password: current, new_password: next }, { withCredentials: true });
      setDone(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Nie udało się zmienić hasła');
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button variant="ghost" onClick={() => { reset(); setOpen(true); }}
        className={className} aria-label="Zmień hasło" data-testid="change-password-button">
        <KeyRound className="w-4 h-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#1E1E1E] border-[#2A2A2A] text-white max-w-md">
          <DialogHeader><DialogTitle className="heading-text text-2xl">Zmień hasło</DialogTitle></DialogHeader>
          {done ? (
            <div className="space-y-4">
              <p className="text-sm text-[#A1A1A1]">Hasło zostało zmienione.</p>
              <Button onClick={() => setOpen(false)} className="w-full rounded-full">Zamknij</Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              {error && <p className="text-red-400 text-sm" data-testid="change-password-error">{error}</p>}
              <div>
                <Label className="label-text text-[#A1A1A1] mb-2 block">OBECNE HASŁO</Label>
                <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required autoComplete="current-password" className="bg-[#0A0A0A] border-[#2A2A2A] rounded-2xl h-12 text-white" />
              </div>
              <div>
                <Label className="label-text text-[#A1A1A1] mb-2 block">NOWE HASŁO (min. 10 znaków, litery i cyfry)</Label>
                <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={10} autoComplete="new-password" className="bg-[#0A0A0A] border-[#2A2A2A] rounded-2xl h-12 text-white" />
              </div>
              <div>
                <Label className="label-text text-[#A1A1A1] mb-2 block">POWTÓRZ NOWE HASŁO</Label>
                <Input type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)} required autoComplete="new-password" className="bg-[#0A0A0A] border-[#2A2A2A] rounded-2xl h-12 text-white" />
              </div>
              <Button type="submit" disabled={busy} className="w-full rounded-full h-12">{busy ? 'Zapisuję...' : 'ZAPISZ'}</Button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
